// extracted by mini-css-extract-plugin
export default {"schoolContainer":"Education_schoolContainer__H9kvh","educationHeading":"Education_educationHeading__xW+00","bottom-fade-blur":"Education_bottom-fade-blur__uNoVf"};